export default __webpack_public_path__ + "static/media/562.3359b57e.png";